
import { styled as muiStyled } from "@mui/material/styles";
import { Box } from "@mui/material";
 
const CommentContentText = muiStyled(Box)({
fontSize: "0.875rem",
lineHeight: 1.43,
color: "text.primary",
"& .mention": {
    backgroundColor: "transparent",
    color: "#09779E !important",
    padding: "0",
    borderRadius: "0",
    fontWeight: "500",
    textDecoration: "none !important",
    cursor: "pointer",
},
});

export {CommentContentText};